import { useMutation, gql } from '@apollo/client';

import { GET_DATEV_NUMBERS } from 'src/hooks/datev-numbers/get-datev-numbers.hook';

import { GET_SUBSIDIARY_COMPANIES_BY_PARENT } from './get-subsidiary-companies.hook';
import { GET_CURRENT_COMPANY } from './get-current-company.hook';
import { GET_PLATFORM_COMPANY_LOCATIONS } from './get-platform-company-locations.hook';
import { GET_PLATFORM_COMPANY_BUSINESS_ADDRESSES } from './get-platform-company-business-addresses.hook';
import { GET_PLATFORM_COMPANY_DEPARTMENTS } from './get-platform-company-departments.hook';

export const UPSERT_COMPANY = gql`
  mutation upsertYuuHrCompany($payload: YuuHrCompanyInput!) {
    upsertYuuHrCompany(payload: $payload) {
      _id
    }
  }
`;

export const useUpsertCompany = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createSubsidiaryCompany] = useMutation(UPSERT_COMPANY, {
    onCompleted: onSuccess,
    refetchQueries: [
      GET_SUBSIDIARY_COMPANIES_BY_PARENT,
      GET_CURRENT_COMPANY,
      GET_DATEV_NUMBERS,
      GET_PLATFORM_COMPANY_LOCATIONS,
      GET_PLATFORM_COMPANY_BUSINESS_ADDRESSES,
      GET_PLATFORM_COMPANY_DEPARTMENTS,
    ],
  });

  return createSubsidiaryCompany;
};
